<template>
    <a-dropdown :trigger="['click']" ref="lang-dropdown">
        <a-button type="ghost" shape="circle" size="large">
            <i :class="localeClass(locale)" />
        </a-button>
        <a-menu slot="overlay">
            <a-menu-item v-for="(locale, index) in locales" :key="index">
                <a-button
                    type="ghost"
                    shape="circle"
                    size="large"
                    @click="setLocale(locale)"
                >
                    <i :class="localeClass(locale)" />
                </a-button>
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {}
    },

    created() {},

    methods: {
        ...mapActions(['changeLocaleTo']),

        setLocale(locale) {
            this.$i18n.locale = locale
            this.changeLocaleTo(locale).then(() => {
                window.location.reload()
            })
        },

        localeClass(locale) {
            return 'flag-icon flag-icon-' + locale
        },
    },

    computed: {
        ...mapGetters(['locale', 'locales']),
    },
}
</script>
